const IMAGES = [
  { src: '/2nd.webp',                          alt: 'No safety gear detected',            label: 'No Safety Gear' },
  { src: '/2nd1.webp',                         alt: 'Violation of compliance detected',    label: 'Violation of Compliance' },
  { src: '/2nd2.webp',                         alt: 'PPE Violation detected',              label: 'PPE Violation' },
  { src: '/2nd3.webp',                         alt: 'Non compliance detected',             label: 'Non Compliance' },
  { src: '/2nd4.webp',                         alt: 'Sleeping or distracted worker',       label: 'Sleeping / Distracted' },
  { src: '/PPE%20Violation.webp',              alt: 'No safety gear detected',             label: 'No Safety Gear' },
  { src: '/Idle%20Machinery.webp',             alt: 'Idle machinery detection',            label: 'Idle Machinery' },
  { src: '/unauthorised%20access.webp',        alt: 'Unauthorised access',                 label: 'Unauthorised Access' },
  { src: '/loitering%20and%20inactivity.webp', alt: 'Loitering detection',                 label: 'Loitering & Inactivity' },
  { src: '/attendance%20and%20presence.webp',  alt: 'Attendance tracking',                 label: 'Attendance & Presence' },
];

export default function Gallery() {
  return (
    <section id="gallery" style={{
      width: '100%',
      background: '#fff',
      padding: 'clamp(48px, 7vw, 96px) clamp(16px, 4vw, 48px)',
    }}>

      {/* ── Header — centered, Cardo heading, no line before eyebrow ── */}
      <div style={{
        marginBottom: 'clamp(28px, 4vw, 48px)',
        textAlign: 'center',
      }}>

        {/* Eyebrow — no line, Helvetica Neue */}
        <p style={{
          fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: '#C94B2A',
          marginBottom: 12,
        }}>
          Gallery
        </p>

        {/* Heading — Cardo, centered */}
        <h2 style={{
          fontFamily: "'Cardo', Georgia, serif",
          fontSize: 'clamp(28px, 4vw, 52px)',
          fontWeight: 400,
          color: '#111',
          lineHeight: 1.1,
          margin: 0,
        }}>
          TruVue AI in action
        </h2>
      </div>

      {/* ── Masonry grid ── */}
      <div className="gallery-grid">
        {IMAGES.map((img) => (
          <div key={img.src} className="gallery-card">
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
              }}
            />
            <div className="gallery-label">
              {img.label}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .gallery-grid {
          max-width: 1280px;
          margin: 0 auto;
          columns: 3;
          column-gap: clamp(10px, 1.4vw, 16px);
        }

        .gallery-card {
          position: relative;
          break-inside: avoid;
          margin-bottom: clamp(10px, 1.4vw, 16px);
          border-radius: clamp(8px, 1.2vw, 14px);
          overflow: hidden;
          background: #f0f0f0;
          cursor: pointer;
        }

        .gallery-label {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 32px 14px 12px;
          background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 100%);
          color: #fff;
          font-family: 'Cardo', Georgia, serif;
          font-size: clamp(12px, 1.1vw, 14px);
          font-weight: 700;
          letter-spacing: 0.02em;
          opacity: 0;
          transform: translateY(6px);
          transition: opacity 0.25s ease, transform 0.25s ease;
          pointer-events: none;
        }

        .gallery-card:hover .gallery-label {
          opacity: 1;
          transform: translateY(0);
        }

        /* Touch devices — labels always visible */
        @media (hover: none) {
          .gallery-label {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
        }

        /* Tablet */
        @media (max-width: 860px) {
          .gallery-grid { columns: 2; }
        }

        /* Mobile */
        @media (max-width: 480px) {
          .gallery-grid { columns: 2; column-gap: 8px; }
          .gallery-card { margin-bottom: 8px; border-radius: 8px; }
        }
      `}</style>
    </section>
  );
}
